'use client';

import { ReactNode, useEffect, useState } from 'react';

import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

export function PHProvider({ children }: { children: ReactNode }) {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize PostHog synchronously — must complete before identify() is called
    // in with-auth.tsx. Previously deferred via requestIdleCallback, which caused a
    // race condition where identify() fired on an uninitialized instance, breaking
    // anonymous → identified user merging (and all UTM attribution with it).
    if (typeof window !== 'undefined' && !isInitialized) {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: 'https://augur.julius.ai',
        ui_host: 'https://us.posthog.com',
        person_profiles: 'identified_only',
        capture_pageview: false, // Disable automatic pageview capture, as we capture manually
        disable_session_recording: false
      });
      posthog.capture('bootstrap_profile', {
        $set_once: {
          created_at: new Date().toISOString()
        }
      });
      setIsInitialized(true);
    }
  }, [isInitialized]);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
